(function () {
  function formatPrice(cents) {
    if (typeof formatMoney === "function" && window.MinimogSettings && window.MinimogSettings.money_format) {
      return formatMoney(cents, window.MinimogSettings.money_format);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2);
  }

  function initBundle(root) {
    var swatches = root.querySelectorAll(".klar-fpb__swatch");
    if (!swatches.length) return;

    var variantInput = root.querySelector("[data-fpb-variant-input]");
    var priceEl = root.querySelector("[data-fpb-price]");
    var compareEl = root.querySelector("[data-fpb-compare-price]");
    var variantsEl = root.querySelector("[data-fpb-variants]");
    var variants = [];

    if (variantsEl) {
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (e) {}
    }

    swatches.forEach(function (swatch) {
      swatch.addEventListener("click", function () {
        var optionIndex = swatch.getAttribute("data-option-index");

        root.querySelectorAll('.klar-fpb__swatch[data-option-index="' + optionIndex + '"]').forEach(function (s) {
          s.classList.remove("is-active");
        });
        swatch.classList.add("is-active");

        var colorLabel = root.querySelector('[data-fpb-color-name="' + optionIndex + '"]');
        if (colorLabel) {
          colorLabel.textContent = swatch.getAttribute("data-color-name");
        }

        var selectedOptions = {};
        root.querySelectorAll(".klar-fpb__swatch.is-active").forEach(function (s) {
          var idx = s.getAttribute("data-option-index");
          selectedOptions[idx] = s.getAttribute("data-option-value");
        });

        var matched = variants.find(function (v) {
          return Object.keys(selectedOptions).every(function (idx) {
            return v.options[parseInt(idx, 10)] === selectedOptions[idx];
          });
        });

        if (matched && variantInput) {
          variantInput.value = matched.id;
        }

        if (matched && priceEl) {
          priceEl.textContent = formatPrice(matched.price);
        }

        if (matched && compareEl) {
          if (matched.compare_at_price && matched.compare_at_price > matched.price) {
            compareEl.textContent = formatPrice(matched.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }

        var src = swatch.getAttribute("data-image-src");
        var srcset = swatch.getAttribute("data-image-srcset");
        var alt = swatch.getAttribute("data-image-alt");
        var img = root.querySelector('[data-fpb-image="' + optionIndex + '"]');

        if (img && src) {
          img.src = src;
          if (srcset) img.srcset = srcset;
          if (alt) img.alt = alt;
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll("[data-klar-featured-bundle]").forEach(initBundle);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", initAll);
})();
